/*
1.上传文件公用封装已挂在Vue原型实力对象上，调用this.$UPLOADFILEOSS(file,  fileName, isShowLoading)
2.上传设置参数在配置文件/static/config.json
*/




import Vue from 'vue'
// 本地上传地址
const zuul = Vue.prototype.zuul
// 是否开启OSS上传
const isOss = Vue.prototype.isOss
// 分片并发上传数量
const ossParallel = Vue.prototype.ossParallel
// 分片大小 定义的是MB上传时需转换为b
const ossPartSize = Vue.prototype.ossPartSize
// 多少MB使用分片上传
const multipartUploadSize = Vue.prototype.multipartUploadSize
const ossConfig = Vue.prototype.ossConfig
import axios from "@/http/axios"
import { Message, Loading } from 'element-ui';
// 获取当前时分秒
function getCurrentTime () {
    var now = new Date();
    var year = now.getFullYear();
    var month = (now.getMonth() + 1).toString().padStart(2, '0');
    var day = now.getDate().toString().padStart(2, '0');
    var hour = now.getHours().toString().padStart(2, '0');
    var minute = now.getMinutes().toString().padStart(2, '0');
    var second = now.getSeconds().toString().padStart(2, '0');

    var currentTime = year + month + day + hour + minute + second;
    return currentTime;
}
// 随机字符串len长度
export const randomString = function(len) {
    len = len || 32
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length
    var pwd = ''
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
}

// 上传文件
// 1.测试环境上传服务器
// 2.线上环境上传ALI-OSS  大于10M切片上传
// file文件，filaName文件名称，isShowLoading上传时是否显示loading
export const UPLOADFILEOSS = (file, fileName, isShowLoading = false) => {
    fileName = fileName ? fileName : `${getCurrentTime()}-${randomString(6)}`;
    var fileType = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2)
    console.log(file, 'file', fileName, 'fileName', isShowLoading, 'isShowLoading', fileType, 'fileType')
    console.log('isOss', isOss, 'ossParallel', ossParallel, 'ossPartSize', ossPartSize, 'multipartUploadSize', multipartUploadSize);

    if (!file) {
        Message.error('未选择上传文件')
        return Promise.reject(false)
    }
    return new Promise(async (resolve, reject) => {
        // 服务器上传
        if (!isOss) {
            fileType = Vue.prototype.fileType
            let fd = new FormData();
            fd.append("file", file);
            fd.append("type", fileType);
            axios({
                hostUrl: zuul,
                url: "/xyj-admin/w/FileUploadController/uploadFileType",
                method: "post",
                data: fd
            }).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        }

        // oss上传
        else {
            // fileName = `/${fileType}/${fileName}.${fileType}`
            fileName = `${fileName}.${fileType}`

            try {
                const OSS = require('ali-oss');
                const client = new OSS(
                    ossConfig
                    //     {
                    //     // yourregion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                    //     region: 'oss-cn-beijing',
                    //     secure: true, // secure: 配合region使用，如果指定了secure为true，则使用HTTPS访问
                    //     // 从环境变量中获取访问凭证。运行本代码示例之前，请确保已设置环境变量OSS_ACCESS_KEY_ID和OSS_ACCESS_KEY_SECRET。
                    //     accessKeyId: 'LTAI5tFfNCbdUnphbz7q353P',
                    //     accessKeySecret: 'lyRd22LR5uO0C6nXjZpya1uwsiXHF5',
                    //     // 填写Bucket名称。
                    //     bucket: 'lyhhy'
                    // }
                );
                // 大于10M分片上传
                if (file.size > multipartUploadSize * 1024 * 1024) {
                    if (isShowLoading) {
                        var loading = Loading.service({
                            text: '上传中请稍等...'
                        })
                    }
                    // 依次填写Object完整路径（例如exampledir/exampleobject.txt）和本地文件的完整路径（例如D:\\localpath\\examplefile.txt）。Object完整路径中不能包含Bucket名称。
                    // 如果本地文件的完整路径中未指定本地路径（例如examplefile.txt），则默认从示例程序所属项目对应本地路径中上传文件。
                    const res = await client.multipartUpload(fileName, file, {
                        progress: (progress, _checkpoint) => {
                            console.log(progress, '进度', _checkpoint, '分片上传的断点信息');
                            if (isShowLoading) {
                                loading.text = `正在上传，已完成 ${(progress * 100).toFixed(2)}%`
                            }
                        },
                        parallel: ossParallel,  //分片数量
                        partSize: ossPartSize * 1024 * 1024, // 分片大小
                        // headers,
                        // // 指定meta参数，自定义Object的元信息。通过head接口可以获取到Object的meta数据。
                        // meta: {
                        //     year: 2020,
                        //     people: 'test',
                        // },
                    });
                    let url = `https://${ossConfig.bucket}.${ossConfig.region}.aliyuncs.com/${res.name}`
                    console.log(res, 'oss分片上传回调');
                    isShowLoading && loading.close()
                    resolve(url)
                } else {
                    // 自定义请求头
                    const res = await client.put(fileName, file)
                    console.log(res, 'oss上传回调');
                    resolve(res.url)
                }
            } catch (error) {
                console.log(error, '上传出错');
                isShowLoading && file.size > multipartUploadSize * 1024 * 1024 && loading.close()
                reject(error)
            }
        }
    })
}


let timer; let
    flag
/**
 * 节流原理：在一定时间内，只能触发一次
 *
 * @param {Function} func 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 */
export function throttle (func, wait = 500, immediate = true) {
    if (immediate) {
        if (!flag) {
            flag = true
            // 如果是立即执行，则在wait毫秒内开始时执行
            typeof func === 'function' && func()
            timer = setTimeout(() => {
                flag = false
            }, wait)
        }
    } else if (!flag) {
        flag = true
        // 如果是非立即执行，则在wait毫秒内的结束处执行
        timer = setTimeout(() => {
            flag = false
            typeof func === 'function' && func()
        }, wait)
    }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js